import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Card, Image } from 'semantic-ui-react';
import PublicationService, { Publication } from './PublicationService';
import { AppContext } from '../../model/context/app/app';

export interface PublicationViewProps {
    selectedPublication?: Publication | null;
    onClick: (p: Publication) => void;
    onDoubleClick: (p: Publication) => void;
}

const publicationService = new PublicationService();
export const PublicationView: FunctionComponent<PublicationViewProps> = ({
    selectedPublication = null,
    onClick,
    onDoubleClick,
}) => {
    const context = useContext(AppContext);

    const [publications, setPublications] = useState<Publication[]>([]);
    const loadAndSetPublications = () => {
        publicationService
            .loadPublications(undefined, undefined, context.token)
            .then(
                (value) => setPublications(publicationService.mapToPublicationView(value)),
                (reason) => console.error(reason)
            )
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        loadAndSetPublications();
    }, []);

    return (
        <Card.Group itemsPerRow={6}>
            {publications.map((p, idx) => (
                <Card
                    onDoubleClick={() => onDoubleClick(p)}
                    color={p.id === selectedPublication?.id ? 'red' : undefined}
                    key={idx}
                    onClick={() => onClick(p)}>
                    <Image src={p.teaserImage} wrapped ui={false} />

                    <Card.Content>
                        <Card.Header>{p.title}</Card.Header>
                        <Card.Meta>
                            <span>ID: {p.id} </span>
                            <br />
                            <span>Kategorieangebot: {p.isCategory ? 'ja' : 'nein'}</span>
                        </Card.Meta>
                        <Card.Description>{p.description}</Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                        <span>Publikationsstatus: {p.status}</span>
                    </Card.Content>
                </Card>
            ))}
        </Card.Group>
    );
};
